<template>
  <div class="w-100">
    <div class=" p-list-representation-wrapper align-items-start">
      <Loader class="w-100" :loading="loading">
        <div  class="w-100p-list-representation-content row mr-auto ml-auto align-items-start">
          <div class="w-100" >
            <appHeader></appHeader>
          </div>
          <div class=" row p-list-representation-data w-100">
            <contentList
            :loading.sync="loading"
            :all-sans="allSans"
            :form-data="formData"
            :close-modal="closeModal"
            @submitEditSansModal="submitEditSansModal"
            @deleteSans="deleteSans"
            @getSans="getSans"
            ></contentList>
          </div>

        </div>
      </Loader>

    </div>

  </div>
</template>

<script>
import contentList from '../components/managementTodaySalon/contentList'
import appHeader from '../components/includes/AppHeader'

export default {
  name: 'managementTodaySalon',
  components: {
    contentList,
    appHeader
  },

  props: {

  },

  data () {
    return {
      loading: true,
      allSans: [],
      formData: {
        start_time: '',
        end_time: '',
        hall_id: '',
        value_update_start_time: '',
        value_update_end_time: ''

      },
      closeModal: 0
    }
  },

  watch: {
    formData (data) {
      this.getSans()
    }
  },

  created () {

  },

  mounted () {
    const getIdParams = this.$route.params.id

    if (typeof (getIdParams) !== 'undefined') {
      const singleData = JSON.parse(localStorage.getItem('hallSingle'))
      singleData.hall_id = getIdParams
      this.formData = singleData
    } else {
      delete this.formData.id
    }
  },

  methods: {
    getSans () {
      this.$store
        .dispatch('managementTodaySalon/getSans', {
          data: {
            hall_id: this.formData.hall_id
          }
        })
        .then((res) => {
          this.loading = false
          if (res.is_successful) {
            if (res.data.length > 0) this.allSans = res.data
            else this.$message.error('سانسی ثبت نشده است.')
          }
        })
    },

    submitEditSansModal (data) {
      this.loading = true

      data.beforeUpdateStartTime = data.start_time
      data.beforeUpdateEndTime = data.end_time

      data.start_time = data.value_update_start_time
      data.end_time = data.value_update_end_time

      this.$store
        .dispatch('managementTodaySalon/editSans', {
          data: {
            ...data
          }
        })
        .then((res) => {
          this.loading = false
          if (res.is_successful) {
            this.closeModal++
          } else {
            data.start_time = data.beforeUpdateStartTime
            data.end_time = data.beforeUpdateEndTime
          }

          if (res == 'error') {
            data.start_time = data.beforeUpdateStartTime
            data.end_time = data.beforeUpdateEndTime
          }
        })
    },

    deleteSans (data) {
      this.loading = true
      data.hall_id = this.formData.hall_id

      this.$store
        .dispatch('managementTodaySalon/removeSans', {
          data: {
            ...data
          }
        })
        .then((res) => {
          this.getSans()
        })
    }

  }

}
</script>
